import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';

/**
 * React Router の遷移ごとに GA4 page_view を発火するコンポーネント。
 * BrowserRouter の直下、ScrollToTop と並列で配置する。
 *
 * - 初回マウント時 (TOPアクセス) も発火
 * - hash変更 (#section) は無視
 */
export default function RouteAnalytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // document.title は React 側で <title> 操作している場合に反映を待つため、
    // 次のフレームで送信
    const id = window.requestAnimationFrame(() => {
      trackPageView(pathname + search);
    });
    return () => window.cancelAnimationFrame(id);
  }, [pathname, search]);

  return null;
}
